/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OrganizationIdRouteImport } from './routes/$organizationId'
import { Route as IndexRouteImport } from './routes/index'

const OrganizationIdRoute = OrganizationIdRouteImport.update({
  id: '/$organizationId',
  path: '/$organizationId',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$organizationId': typeof OrganizationIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$organizationId': typeof OrganizationIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$organizationId': typeof OrganizationIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/$organizationId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/$organizationId'
  id: '__root__' | '/' | '/$organizationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OrganizationIdRoute: typeof OrganizationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$organizationId': {
      id: '/$organizationId'
      path: '/$organizationId'
      fullPath: '/$organizationId'
      preLoaderRoute: typeof OrganizationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OrganizationIdRoute: OrganizationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
